import React from 'react';
import { Navbar, Container, Column} from 'rbx';
import LogoUnipar from '../../../assets/images/logo.svg';
import "../../../styles/header.scss";

function Header() {
  return (
    <Navbar role="navigation" aria-label="navegação principal">
      <Container>
        <Navbar.Brand>
          <a className="navbar-item logoUnipar" href="https://unipar.br">
            <img src={LogoUnipar} alt="Unipar" width="50" height="50" />
          </a>

          <Navbar.Burger
            aria-label="menu"
            aria-expanded="false"
            data-target="navbar-menu">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </Navbar.Burger>
        </Navbar.Brand>

        <Navbar.Menu id="navbar-menu">
          <Navbar.Segment as="div" className="navbar-item navbar-end" align="right">
            <Column.Group>
              VESTIBULAR - PROVA ONLINE
            </Column.Group>
          </Navbar.Segment>
          <Navbar.Segment as="div" className="navbar-item navbar-end" align="right">
            <Column.Group>
              <a href="https://www.unipar.br/vestibular/editais/">EDITAIS</a>
            </Column.Group>
          </Navbar.Segment>
          <Navbar.Segment as="div" className="navbar-item navbar-end" align="right">
            <Column.Group>
              <a href="https://www.unipar.br/vestibular/investimentos/">INVESTIMENTOS</a>
            </Column.Group>
          </Navbar.Segment>
          <Navbar.Segment as="div" className="navbar-item navbar-end" align="right">
            <Column.Group>
              <a href="https://www.unipar.br/vestibular/investimentos/">MANUAL DO CANDIDATO</a>
            </Column.Group>
          </Navbar.Segment>        
        </Navbar.Menu>
      </Container>
    </Navbar>
  )
}

export default Header;